module.exports = __webpack_public_path__ + "9a8a197189b92d86ee3f52a141aa147c.svg";